import * as pdfjsLib from "pdfjs-dist";

// Serve the worker matching the installed pdfjs version from a CDN.
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.mjs`;

export default pdfjsLib;
